import React, { useState } from 'react';
import { Box, Fade, Paper, Typography } from '@mui/material';
import { useLanguage } from 'Context/LanguageContext';
import { LocationSearchTabs, LocationSearchTab, LocationSearchBody } from '../styled';
import SearchByCoordinates from './SearchByCoordinates';
import SearchByPlace from './SearchByPlace';
import { FielderTab, FielderTabs } from '~/Tabs/Tabs.style';

function TabPanel(props) {
	const { children, value, index, lan, ...other } = props;
	return (
		<LocationSearchBody hidden={value !== index} id={`location-type-tabPanel-${index}`} {...other}>
			<Fade
				in={value === index}
				style={{ transitionDelay: value === index ? '100ms' : '0ms' }}
				unmountOnExit
			>
				<Box p={3}>
					<Typography>{children}</Typography>
				</Box>
			</Fade>
		</LocationSearchBody>
	);
}

const SEARCH = 0;
const COORDINATES = 1;

const LocationSearch = ({ address, coordinates, selectLocation, disabled, label, error }) => {
	const lan = useLanguage();

	const [searchType, setSearchType] = useState(SEARCH);

	const handleChangeAssignee = (event, newValue) => {
		setSearchType(newValue);
	};

	return (
		<Paper elevation={1} sx={{ borderTopLeftRadius: 8, borderTopRightRadius: 8 }}>
			<FielderTabs
				value={searchType}
				onChange={handleChangeAssignee}
				centered
			>
				<FielderTab label={lan.byDirection} value={SEARCH} id="nav-search"  />
				<FielderTab label={lan.byCoordinates} value={COORDINATES} id="nav-coordinates"  />
			</FielderTabs>
			<TabPanel value={searchType} index={SEARCH} lan={lan}>
				<SearchByPlace
					address={address}
					selectLocation={selectLocation}
					disabled={disabled}
					label={label}
					error={error}
				/>
			</TabPanel>

			<TabPanel value={searchType} index={COORDINATES} lan={lan}>
				<SearchByCoordinates
					updateCoordinates={selectLocation}
					disabled={disabled}
					coordinates={coordinates}
					error={error}
				/>
			</TabPanel>
		</Paper>
	);
};

export default LocationSearch;
